import * as React from 'react';
import "./styles.scss"
import {VeBoxBlackNavTab} from "./components/VeboxBlackNavBarTab";

interface VeBoxBlackNavBarProps {
    tabs: VeBoxTab[];
    onSelect?: (tabName: string)=> void;
}

export interface VeBoxTab {
    code: string;
    label: string;
    isSelected?: boolean;
}

export const VeBoxBlackNavBar: React.FC<VeBoxBlackNavBarProps> = ({tabs, onSelect}) => {

    const [selectedTab, setSelectedTab] = React.useState<string>();

    const onSelected = (code: string) => () => {
        if(onSelect) {
            onSelect(code);
        }else {
            setSelectedTab(code);
        }
    }

    return <div className={"nav-bar"}>
        {tabs.map(tab => <VeBoxBlackNavTab tabLabel={tab.label} tabCode={tab.code} isSelected={selectedTab===tab.code || tab.isSelected} onSelected={onSelected}/>) }
    </div>
}